import { Fragment } from 'react';
import View from '../../atoms/view';
import { A, H5 } from '../../atoms/text';
import { SidebarCategory } from '../../../constants/sidebarContent';
import { ThemedStyleProps } from '../../../types/fela';
import { canUserAccess } from '../../../utils/userAuthorization';

type SideBarLinkProps = {
  catIndex: number;
  category: SidebarCategory;
  selected: [number, number] | null;
  onClick: (selection: [number, number]) => void;
  userId?: string;
};

const SideBarLink = ({ catIndex, category, selected, onClick, userId }: SideBarLinkProps) => {
  const compareSelected = (array: [number, number] | null) => {
    if (selected === null || array === null) {
      return false;
    }
    return selected[0] === array[0] && selected[1] === array[1];
  };

  return (
    <Fragment key={catIndex}>
      <H5 extend={[styles.sidebar_title, { marginBottom: 0 }]}>{category.category}</H5>
      {category.titles.map((title, titleIndex) =>
        title.hide || !canUserAccess(userId, title.allowedUserIds) ? null : (
          <View
            extend={[styles.link, compareSelected([catIndex, titleIndex]) && styles.link_selected]}
            key={title.title}
          >
            <View style={{ width: '8px' }}> </View>
            <View
              extend={{
                display: 'flex',
                alignItems: 'center',
                width: 22,
                height: 22,
                justifyContent: 'center',
              }}
            >
              {title.icon &&
                (() => {
                  const Icon = title.icon;
                  return <Icon sx={{ fontSize: 22, color: 'inherit' }} />;
                })()}
            </View>
            <View style={{ width: '16px' }}> </View>
            <View>
              <A
                key={titleIndex}
                extend={compareSelected([catIndex, titleIndex]) ? styles.selected : styles.unselected}
                onClick={() => onClick([catIndex, titleIndex])}
                text={title.title}
              />
            </View>
          </View>
        )
      )}
    </Fragment>
  );
};

const styles = {
  sidebar_title: ({ theme: { colors } }: ThemedStyleProps) => ({
    marginLeft: 8,
    marginBottom: 8,
    paddingTop: 12,
    color: colors.black,
    fontWeight: 'bold',
  }),
  selected: { color: 'inherit' },
  unselected: {},
  link: ({ theme: { colors } }: ThemedStyleProps) => ({
    display: 'flex',
    maxHeight: '35px',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '4px 8px 4px 0px',
    marginBottom: '10px',
    letterSpacing: '0.04em',
    '& a': {
      color: colors.darkGrey,
    },
    '& div': {
      color: colors.darkGrey,
    },
    '&:hover': {
      '& a': {
        textDecoration: 'underline',
      },
    },
    '> a': {
      marginTop: 7,
      marginBottom: 7,
    },
  }),
  link_selected: ({ theme: { colors } }: ThemedStyleProps) => ({
    backgroundColor: colors.lightGreen,
    borderRadius: '4px',
    borderBottom: `1px solid ${colors.primaryLight}`,
    '& a': {
      color: colors.green,
    },
    '& svg': {
      color: colors.green,
    },
    '& div': {
      color: colors.primary,
    },
  }),
};

export default SideBarLink;
